import i18n from "../../i18n";
import { v4 as uuidv4 } from "uuid";
import { getErrorMessageKey } from "@/Enums/ErrorCodes";

type MessageType = "error" | "info" | "warning" | "success";

interface Message {
  id: string;
  message: string;
  type: MessageType;
  visible: boolean;
}

interface State {
  messages: Message[];
}

const state: State = {
  messages: [],
};

const getters = {
  messages: (state: State) => state.messages,
};

const mutations = {
  addMessage(state: State, payload: { message: string; type: MessageType }) {
    if (!payload.message?.trim()) return;

    // Limpiar mensajes anteriores para mostrar solo el más reciente
    state.messages = [];

    state.messages.push({
      id: uuidv4(),
      message: payload.message,
      type: payload.type,
      visible: true,
    });
  },

  hideMessage(state: State, id: string) {
    const msg = state.messages.find((m) => m.id === id);
    if (msg) msg.visible = false;
  },

  removeMessage(state: State, id: string) {
    const idx = state.messages.findIndex((m) => m.id === id);
    if (idx !== -1) state.messages.splice(idx, 1);
  },

  clearMessages(state: State) {
    state.messages = [];
  },
};

const actions = {
  /**
   * Mostrar mensaje de información
   */
  info({ commit }: { commit: any }, message: string) {
    commit("addMessage", { message: i18n.global.t(message), type: "info" });
  },

  /**
   * Mostrar mensaje de advertencia
   */
  warning({ commit }: { commit: any }, message: string) {
    commit("addMessage", { message: i18n.global.t(message), type: "warning" });
  },

  /**
   * Mostrar mensaje de éxito
   */
  success({ commit }: { commit: any }, message: string) {
    commit("addMessage", { message: i18n.global.t(message), type: "success" });
  },

  /**
   * Mostrar mensaje de error (clave de traducción directa)
   */
  error({ commit }: { commit: any }, message: string) {
    commit("addMessage", { message: i18n.global.t(message), type: "error" });
  },

  /**
   * Procesar error de API con formato { errorCode: "..." }
   */
  apiError({ commit }: { commit: any }, error: { errorCode?: string }) {
    const errorCode = error?.errorCode || "INTERNAL_ERROR";
    const messageKey = getErrorMessageKey(errorCode);
    const translated = i18n.global.t(messageKey) as string;
    commit("addMessage", { message: translated, type: "error" });
  },

  hide({ commit }: { commit: any }, id: string) {
    commit("hideMessage", id);
  },

  remove({ commit }: { commit: any }, id: string) {
    commit("removeMessage", id);
  },

  clear({ commit }: { commit: any }) {
    commit("clearMessages");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
